import React from 'react';
import PropTypes from 'prop-types';
import KpiChart from '../../../commons/KpiChart';

const ContentCourseSpeechRateGauge = (props) => (
  <KpiChart
    title="Speech recognition difficulty"
    description="The number represents the average record button usage per item execution. The exercises which represent this number are: Presentation, Video Short, Pronunciation, Speech Practice, Unscramble Speech Recognition, Gap Fill, Single Choice Game, Phoneme, Vocabulary and Vocabulary Kids."
    loading={props.loading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    intervals={[0, 2, 3, 5]}
    stepSize={1}
    reverseColors={true}
    onClickHistory={props.onClickHistory}
    formatter={props.formatter}
  />
);

ContentCourseSpeechRateGauge.propTypes = {
  loading: PropTypes.bool.isRequired,
  currentValue: PropTypes.number.isRequired,
  previousValue: PropTypes.number.isRequired,
  onClickHistory: PropTypes.func,
  formatter: PropTypes.func.isRequired,
};

export default ContentCourseSpeechRateGauge;
